module.exports = __webpack_public_path__ + "img/logo2.6ae804b6.png";